import React from 'react';
import { useTranslation } from 'react-i18next';
import Form from '../../../../antd/form/Form/Form';
import { CollapseBlock } from '../../../../common';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField';
import { required } from '../../../../antd/form/FormValidation';
import { SensorAttributeFields } from '../components/SensorAttributeFields';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import FormButton from '../../../../antd/form/FormButton/FormButton';

export function SensorsAttributeForm({
  isCreate,
  isIconDisabled,
  units,
  initials,
  onSubmit,
}) {
  const { t } = useTranslation();

  return (
    <>
      <Form initialValues={initials} onFinish={onSubmit}>
        <CollapseBlock title={t('Všeobecné informácie')}>
          {isCreate ? (
            <FormTextField
              name={'key'}
              label={t('Kľúč')}
              rules={[required(t)]}
            />
          ) : null}

          <SensorAttributeFields
            units={units}
            isIconDisabled={isIconDisabled}
          />
        </CollapseBlock>

        <FormButtonsContainer>
          <FormButton submitOnClick={true}>{t('Uložiť')}</FormButton>
        </FormButtonsContainer>
      </Form>
    </>
  );
}
